var _path, _g, _rect, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSiteBriefing(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 35,
    height: 41,
    viewBox: "0 0 35 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_341_39096",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 35,
    height: 41
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M25.399 0L34.142 8.846V35.695L29.057 35.602V40.68H0V5.085H5.085V0H25.399ZM5.085 7.265H2.179V38.5H26.878V35.602H31.963V35.595H5.085V7.265ZM28.331 25.425H10.897V27.604H28.331V25.425ZM28.331 20.34H10.897V22.519H28.331V20.34ZM28.331 15.255H10.897V17.434H28.331V15.255ZM25.408 3.109L25.424 8.717L31.032 8.8L25.408 3.109Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_341_39096)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40.68H34.141V0H0V40.68Z",
    fill: "#151515"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 40.68H34.141V0H0V40.68Z",
    fill: "#151515"
  }))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 13,
    width: 24,
    height: 17,
    fill: "#151515"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M18.4572 16.8481C19.2538 18.4287 20.4542 19.73 21.917 20.5491C20.4664 21.42 19.295 22.7719 18.5426 24.394C17.7458 22.8132 16.5453 21.5117 15.0823 20.6925C16.533 19.8218 17.7045 18.47 18.4572 16.8481Z",
    fill: "#FFF308",
    stroke: "#FFF308",
    strokeWidth: 2
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M22.7178 15.8129C22.8228 15.937 22.9347 16.0543 23.053 16.164C22.9281 16.286 22.811 16.4168 22.7022 16.5552C22.5972 16.4311 22.4852 16.3138 22.3669 16.2041C22.4918 16.0821 22.609 15.9513 22.7178 15.8129Z",
    fill: "#FFF308",
    stroke: "#FFF308",
    strokeWidth: 2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSiteBriefing);
export default __webpack_public_path__ + "static/media/site-briefing.b38129d1fd162e3b17f82adf18eebe1f.svg";
export { ForwardRef as ReactComponent };